// extracted by mini-css-extract-plugin
export default {"right":"HeaderRightContent_right__KmCMF"};